
export const emailValidationRules = {

    data() {
        return {
            emailValidationRules: [
                v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || !v || 'E-mail must be valid'
            ],
        }
    }
}

